import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { SubSink } from 'subsink';
import { EventEmitterContract } from '../../core/services/ui/event-emitter.contract';
import { ClientsSearchTableComponent } from '../clients-search-table/clients-search-table.component';

@Component({
  selector: 'howden-clients-search-dialog',
  templateUrl: './clients-search-dialog.component.html',
  imports: [
    ClientsSearchTableComponent,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton
  ]
})
export class ClientsSearchDialogComponent implements OnInit, OnDestroy {
  private eventEmitterSrv = inject(EventEmitterContract);
  private dialogRef = inject<MatDialogRef<any>>(MatDialogRef);

  private _subscriptions = new SubSink();

  ngOnInit() {
    //Nos suscribmos al evento que nos indica que se ha seleccionado un cliente
    this._subscriptions.sink = this.eventEmitterSrv.selectClientSearchTableEmit.subscribe((clientSelected) => {
      //Cerramos el diálogo, devolviendo al componente el cliente seleccionado
      this.dialogRef.close(clientSelected);
    });
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  onCancel(): void {
    //Cerramos sin devolver resultado/cliente
    this.dialogRef.close(null);
  }
}
